export default () => value => (value ? he.decode(value) : value);



// WEBPACK FOOTER //
// src/app/common/filters/decode.filter.ts